import { render, staticRenderFns } from "./TracerStudy.vue?vue&type=template&id=1772cbdb"
import script from "./TracerStudy.vue?vue&type=script&lang=ts"
export * from "./TracerStudy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports